/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentSucceededReceiptPayload } from './PaymentSucceededReceiptPayload';
import {
    PaymentSucceededReceiptPayloadFromJSON,
    PaymentSucceededReceiptPayloadFromJSONTyped,
    PaymentSucceededReceiptPayloadToJSON,
    PaymentSucceededReceiptPayloadToJSONTyped,
} from './PaymentSucceededReceiptPayload';

/**
 * 
 * @export
 * @interface CardDataDto
 */
export interface CardDataDto {
    /**
     * 
     * @type {boolean}
     * @memberof CardDataDto
     */
    isRepublish: boolean;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof CardDataDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    acquirerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    aid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    authorisePspReference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    cardExpiryDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    cardScheme?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    cardSummary?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CardDataDto
     */
    formattedReceipt?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    fundingSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    issuerCountry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    loyaltyToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    mid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    partialPan?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentAccountReference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    paymentMethodVariant?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    poiid?: string | null;
    /**
     * 
     * @type {PaymentSucceededReceiptPayload}
     * @memberof CardDataDto
     */
    receipt?: PaymentSucceededReceiptPayload | null;
    /**
     * 
     * @type {string}
     * @memberof CardDataDto
     */
    tid?: string | null;
}



/**
 * Check if a given object implements the CardDataDto interface.
 */
export function instanceOfCardDataDto(value: object): value is CardDataDto {
    if (!('isRepublish' in value) || value['isRepublish'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    return true;
}

export function CardDataDtoFromJSON(json: any): CardDataDto {
    return CardDataDtoFromJSONTyped(json, false);
}

export function CardDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isRepublish': json['isRepublish'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentReference': json['paymentReference'],
        'acquirerId': json['acquirerId'] === undefined ? undefined : json['acquirerId'] === null ? null : json['acquirerId'],
        'aid': json['aid'] === undefined ? undefined : json['aid'] === null ? null : json['aid'],
        'authorisePspReference': json['authorisePspReference'] === undefined ? undefined : json['authorisePspReference'] === null ? null : json['authorisePspReference'],
        'cardExpiryDate': json['cardExpiryDate'] === undefined ? undefined : json['cardExpiryDate'] === null ? null : json['cardExpiryDate'],
        'cardScheme': json['cardScheme'] === undefined ? undefined : json['cardScheme'] === null ? null : json['cardScheme'],
        'cardSummary': json['cardSummary'] === undefined ? undefined : json['cardSummary'] === null ? null : json['cardSummary'],
        'formattedReceipt': json['formattedReceipt'] === undefined ? undefined : json['formattedReceipt'] === null ? null : json['formattedReceipt'],
        'fundingSource': json['fundingSource'] === undefined ? undefined : json['fundingSource'] === null ? null : json['fundingSource'],
        'issuerCountry': json['issuerCountry'] === undefined ? undefined : json['issuerCountry'] === null ? null : json['issuerCountry'],
        'loyaltyToken': json['loyaltyToken'] === undefined ? undefined : json['loyaltyToken'] === null ? null : json['loyaltyToken'],
        'mid': json['mid'] === undefined ? undefined : json['mid'] === null ? null : json['mid'],
        'partialPan': json['partialPan'] === undefined ? undefined : json['partialPan'] === null ? null : json['partialPan'],
        'paymentAccountReference': json['paymentAccountReference'] === undefined ? undefined : json['paymentAccountReference'] === null ? null : json['paymentAccountReference'],
        'paymentMethodVariant': json['paymentMethodVariant'] === undefined ? undefined : json['paymentMethodVariant'] === null ? null : json['paymentMethodVariant'],
        'poiid': json['poiid'] === undefined ? undefined : json['poiid'] === null ? null : json['poiid'],
        'receipt': json['receipt'] === undefined ? undefined : json['receipt'] === null ? null : PaymentSucceededReceiptPayloadFromJSON(json['receipt']),
        'tid': json['tid'] === undefined ? undefined : json['tid'] === null ? null : json['tid'],
    };
}

export function CardDataDtoToJSON(json: any): CardDataDto {
    return CardDataDtoToJSONTyped(json, false);
}

export function CardDataDtoToJSONTyped(value?: CardDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isRepublish': value['isRepublish'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentReference': value['paymentReference'],
        'acquirerId': value['acquirerId'],
        'aid': value['aid'],
        'authorisePspReference': value['authorisePspReference'],
        'cardExpiryDate': value['cardExpiryDate'],
        'cardScheme': value['cardScheme'],
        'cardSummary': value['cardSummary'],
        'formattedReceipt': value['formattedReceipt'],
        'fundingSource': value['fundingSource'],
        'issuerCountry': value['issuerCountry'],
        'loyaltyToken': value['loyaltyToken'],
        'mid': value['mid'],
        'partialPan': value['partialPan'],
        'paymentAccountReference': value['paymentAccountReference'],
        'paymentMethodVariant': value['paymentMethodVariant'],
        'poiid': value['poiid'],
        'receipt': PaymentSucceededReceiptPayloadToJSON(value['receipt']),
        'tid': value['tid'],
    };
}

